import {Injectable} from '@angular/core';
import {Actions, createEffect, CreateEffectMetadata, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {selectSite} from '../init/init.selectors';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {TypedAction} from '@ngrx/store/src/models';
import {Serializer, SerializerResponse, Serializers} from '../../interfaces/serializer';
import {loadDataSourceProviders, loadDataSourceProvidersSuccess} from './dataSourceProviders.actions';
import {map} from 'rxjs/operators';
import {DataSourcesService} from '../../services/data-sources.service';
import {Site} from '../../interfaces/site';
import {DataSourceProvider} from './dataSourceProviders';

@Injectable()
export class DataSourceProvidersEffects {
  private readonly _dataset$: Observable<Serializer<Site>> = this._store.select(selectSite);

  private readonly _load$: Observable<TypedAction<string> & { dataSources: Serializers<any> }> & CreateEffectMetadata = createEffect((): Observable<TypedAction<string> & { dataSources: Serializers<DataSourceProvider> }> => this._actions$.pipe(
    ofType(loadDataSourceProviders),
    withLatestFrom(this._dataset$),
    switchMap(([_, dataset]: [TypedAction<string>, Serializer<Site>]): Observable<SerializerResponse<Serializers<any>>> => this._dataSourcesService.getDataSourceProvider(dataset)),
    map((response: SerializerResponse<Serializers<DataSourceProvider>>): TypedAction<string> & { dataSources: Serializers<DataSourceProvider> } => loadDataSourceProvidersSuccess({
      dataSources: response.data
    }))
  ));

  constructor(
    private readonly _actions$: Actions,
    private readonly _store: Store<AppState>,
    private readonly _dataSourcesService: DataSourcesService
  ) {}
}
